<div class="results mt-5">
  <div class="d-flex align-items-md-center flex-column flex-md-row">
    <h2 class="mb-2 txt txt--section txt--grey">Resultados</h2>
    <p
      *ngIf="detailRequestsByFilter.length > 0"
      class="mb-1 ml-md-2 txt txt--paragraph txt--grey js-show"
    >
      ({{ detailRequestsByFilter.length }} solicitudes)
    </p>
  </div>
  <p
    *ngIf="detailRequestsByFilter.length < 1"
    class="mt-1 mt-md-0 txt txt--paragraph txt--grey js-show"
  >
    No se han encontrado resultados con la búsqueda, por favor intentar con
    filtros diferentes.
  </p>
  <!-- <p class="mt-1 mt-md-0 txt txt--paragraph txt--grey js-show">MEL - Del 01/01/2020 al 01/01/2021 - Todas las
      solicitudes</p> -->
  <div *ngIf="detailRequestsByFilter.length > 0" class="js-show">
    <div class="mt-2 mt-lg-5 table-overflow">
      <table class="table">
        <thead>
          <tr>
            <th class="hover-hand">
              <div class="table-head headerTable">
                <p>Asset</p>
              </div>
            </th>
            <th class="hover-hand">
              <div class="table-head headerTable">
                <p>Tipo</p>
              </div>
            </th>
            <th class="hover-hand">
              <div class="table-head headerTable">
                <p>Nombre solicitante</p>
              </div>
            </th>
            <th class="hover-hand">
              <div class="table-head headerTable">
                <p>Nº solicitud</p>
              </div>
            </th>
            <th class="hover-hand">
              <div class="table-head headerTable">
                <p>Estado</p>
              </div>
            </th>
            <th class="hover-hand">
              <div class="table-head headerTable">
                <p>Fecha solicitud</p>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let itemDetail of detailRequestsByFilter ;
              let i = index
            "
          >
            <td>{{ itemDetail.asset }}</td>
            <td>{{ itemDetail.type }}</td>
            <td>{{ itemDetail.requesterName }}</td>
            <td>{{ itemDetail.requestNumber }}</td>
            <td>
              <img
                class="mr-2"
                [src]="imagesStatus[formatStatus(itemDetail.state)]"
              />
              {{ itemDetail.state }}
            </td>
            <td>{{ itemDetail.requestDate | date: "dd/MM/yyyy" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="u-mt30">
      <button type="button" class="btn btn--primary" (click)="export()">
        Descargar reporte completo
      </button>
    </div>
  </div>
</div>
